export default __webpack_public_path__ + "static/media/icon_link.ad1c4ae8.svg";